import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { managementTeam } from '../data/mockData';
import { useScrollReveal } from '../hooks/useScrollReveal';

const TeamSection = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      id="team"
      className="py-20 lg:py-28 bg-white"
      data-testid="team-section"
    >
      <div className="section-container">
        <div
          className={`text-center max-w-3xl mx-auto mb-14 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <p
            className="text-[10px] font-semibold uppercase tracking-[3px] text-[#00BCE4] mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            The People Behind Imprint
          </p>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Meet the <span className="text-[#00BCE4]">Management Team</span>
          </h2>
          <p
            className="text-base text-gray-600 leading-relaxed"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Decades of hands-on print &amp; MIS expertise. Approachable, pragmatic, and dedicated to your success.
          </p>
        </div>

        {/* Headshot strip */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-10 mb-12 max-w-5xl mx-auto">
          {managementTeam.map((person, index) => (
            <Link
              to="/team"
              key={person.id}
              data-testid={`team-headshot-${person.id}`}
              aria-label={`Read more about ${person.name} on the Meet the Team page`}
              className={`group text-center transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="relative overflow-hidden rounded-2xl bg-gray-100 aspect-[4/5] mb-4 shadow-sm">
                <img
                  src={person.image}
                  alt={person.name}
                  loading="lazy"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
              <h3
                className="text-base font-bold text-gray-900 mb-1"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                {person.name}
              </h3>
              <p
                className="text-xs text-gray-500 uppercase tracking-wider"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                {person.role}
              </p>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/team"
            data-testid="team-read-more-cta"
            className="btn-primary text-xs"
          >
            Meet the Team
            <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
